import { CircleDrawer } from "./CircleDrawer";
export async function loadCircleShape(engine, refresh = true) {
    await engine.addShape("circle", new CircleDrawer(), refresh);
}
